module.exports = __webpack_public_path__ + "img/arm-break-coffee-257897.0342630c.jpg";